module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-right.b71e7561.svg";